<template>
  <section class="page3">
    <article class="container">
      <wl-title title='联系我们' :isNeedDesc=false></wl-title>
      <section class="flexWrap">
        <section v-for="(item,idx) in page3Data" :key="item.key">
          <section class="flex">
            <section class="_icon " :style="`background-position: -${60*idx}px -277px;`"></section>
            <h3>{{item.title}}</h3>
          </section>
            <p>{{item.desc}}</p>
        </section>
      </section>
      <section class="img"><img src="/static/img/about/wl-loc.png" alt="地址广州市天河区棠安路188号303、310室"></section>
    </article>
  </section>
</template>

<script>
export default {
  name: 'contactPage',
  data() {
    return {
      page3Data: [
        { title: '电话', desc: '020-37267381 | 400-169-8169', key: 'about-tel' },
        { title: 'QQ', desc: '3475907522', key: 'about-qq' },
        { title: '邮箱', desc: 'yewu@weileit.com', key: 'about-em' },
        { title: '地址', desc: '广州市天河区棠安路188号303、310室', key: 'about-add' },
      ],
    }
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
._icon {
  background: url("/static/img/about/icon-sprite.png");
}
p {
  white-space: pre-line;
  font-size: 24px;
  line-height: 24px;
  color: #8e8e8e;
  padding-top: 6px;
}
h3 {
  font-size: 24px;
  line-height: 24px;
  color: #262626;
  padding-left: 12px;
}
.page3 {
  height: 832px;
  padding-top: 136px;
  ._icon {
    height: 63px;
    width: 60px;
  }
  .flexWrap {
    padding-top: 66px;
    padding-bottom: 64px;
  }
  .flex {
    text-align: left;
    align-items: center;
    section {
      margin-left: 8px;
    }
  }
}
</style>
